import React from 'react'
import { cn } from '../../lib/helpers'
import * as styles from './Button.module.css'
import PropTypes from 'prop-types'
import { ArrowRightIcon } from '../icons/ArrowRightIcon'

/**
 * Outlined button — convenience wrapper for the outline dark variant.
 * Use `color="light"` for the white-border version on dark backgrounds.
 */
export const OutlinedButton = ({ onClick, buttonText, color = 'dark', centered, withArrow }) => {
  const styleClass = color === 'light' ? styles.outlineLight : styles.outlineDark

  return (
    <button
      onClick={onClick}
      className={cn(styleClass, centered ? styles.buttonCentered : '')}
    >
      {buttonText}
    </button>
  )
}

OutlinedButton.defaultProps = {
  color: 'dark',
  withArrow: false,
}

OutlinedButton.propTypes = {
  buttonText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  color: PropTypes.oneOf(['dark', 'light']),
  centered: PropTypes.bool,
  withArrow: PropTypes.bool,
}
